var _rect, _path, _path2, _path3, _path4, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-62"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 51.85,
    y: 123.72,
    width: 70.88,
    height: 70.88,
    rx: 5.4,
    transform: "translate(-82.86 222.42) rotate(-81.65)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.69,136c-11.92-1.75-23.1,7.21-25,20S72,180.61,83.89,182.36s23.11-7.22,25-20S102.62,137.72,90.69,136ZM91,174.3a6.24,6.24,0,0,1-6.28,2.64,7.58,7.58,0,0,1-5.91-6.38,51.57,51.57,0,0,1,.69-12.89c.76-5.19,2.15-10.64,3.94-13.85s4.64-4.07,6.62-3.78,4.89,1.66,5.75,6.51c.66,3.69.24,8-.56,13.43C94.46,165.65,93.27,171.11,91,174.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414,96.05a32.83,32.83,0,0,1-1.24-4.7,3.11,3.11,0,0,0-1.42-2.11,11.85,11.85,0,0,0-1.69-.39c-2-.59-2.54-3.37-4.42-4.23a6.51,6.51,0,0,0-1.9-.4c-2.52-.3-5.13-1.17-6.72-3.15a12.52,12.52,0,0,0-1.55-1.92,1.87,1.87,0,0,0-2.28-.21l1.58,3.18a8.63,8.63,0,0,0,1.76,2.66,2.87,2.87,0,0,0,3,.63,2,2,0,0,1,1-.35,1.11,1.11,0,0,1,.65.42c1.37,1.52.92,4-.42,5.6a12.91,12.91,0,0,1-5.22,3.11,4.07,4.07,0,0,1-2.13.41c-1.32-.24-2-1.68-2.4-3-.87-2.85-1.28-5.95-3.05-8.36A10.31,10.31,0,0,1,386,80.94c-.36-1-.27-2.07-.85-2.92s-1.86-1.39-1.95-2.46a2,2,0,0,1,1.25-1.72c.68-.33,1.45-.43,2.15-.71.28-.12.59-.32.6-.62,0-.45-.62-.63-.78-1s.31-.91.51-1.37c.44-1-.65-2.1-1.7-2.52s-2.31-.74-2.8-1.76a5.59,5.59,0,0,1-.34-1.52,3.36,3.36,0,0,0-2.5-2.75A2.19,2.19,0,0,0,377,63.8a9.34,9.34,0,0,0,.95,1.93c.29.66.21,1.64-.47,1.85-1.12.34-2.2-1.7-3.13-1,.38,1.31.75,2.62,1.14,3.94-1.47.74-3.23-.61-3.86-2.14s-.65-3.27-1.39-4.74-2.76-2.58-4-1.53c-.06,1.89,2.44,2.66,3.55,4.19a2.57,2.57,0,0,1-.5,3.61c-1.17.7-3-.52-2.59-1.81.16-.45.53-.82.57-1.3s-.45-1.07-.91-1.46l-2.14-1.8a4.57,4.57,0,0,0-1.52-.95c-1.47-.43-2.94.76-3.72,2.07s-1.21,2.87-2.29,4a4.18,4.18,0,0,1-5.92,0c-1.46-1.67-.71-4.8,1.43-5.41.81-.22,1.83-.2,2.26-.91.74-1.27-1.39-2.89-.65-4.16.56-1,2.05-.54,3.14-.87s1.68-1.41,2.32-2.35,1.62-1.86,2.72-1.62a3.45,3.45,0,0,1,.12-1.94,1.19,1.19,0,0,1,1.63-.59,2,2,0,0,0,1.05,2.58,5.71,5.71,0,0,0,3.1.23c1.05-.13,2.36-.51,2.44-1.56a3.85,3.85,0,0,1,0-1c.46-1.24,2.76.47,3.64-.53.52-.52-.05-1.45-.76-1.62a7.88,7.88,0,0,0-2.16.11c-.73,0-1.61-.35-1.64-1.08s.76-1.22.85-1.93c.14-1.19-1.89-1.5-2.6-.53s-.46,2.3-.24,3.48.33,2.58-.55,3.41c-.37.57-1.34.27-1.66-.33a4.92,4.92,0,0,1-.31-2,1.71,1.71,0,0,0-1-1.63,3.66,3.66,0,0,0-1.42.16c-1.85.22-3.14-2.17-2.55-3.94s2.26-2.92,3.89-3.82c1.19-.66,2.67-1.28,3.85-.61.55.31.94.84,1.48,1.16.94.56,2.1.35,3.17.37A7.49,7.49,0,0,1,377,43.5c.47.44.92,1.16.55,1.69s-1.57.67-1.36,1.32A2.31,2.31,0,0,0,379,44.64a1.94,1.94,0,0,1,1.12,1.58,3.46,3.46,0,0,1,5.06.41,4.48,4.48,0,0,0,.93,1.21c.43.27,1.18.14,1.23-.36a1,1,0,0,0-.09-.47c-.25-.73-.52-1.44-.77-2.15,1-.54,2.16.29,2.83,1.19,2.49,3.33,4.27,1.33,7.78,1.87,2.38.36,3.42,1.89,4.76,3.73C406,57.31,411.42,62,415.16,67.88c.39.61.76,1.24,1.1,1.88-.07-.16-.12-.32-.18-.48a65.76,65.76,0,0,0-5.43-11c-.46-.74-.93-1.48-1.41-2.2-.3-.45-.61-.91-.92-1.34-.39-.58-.8-1.13-1.22-1.69s-.66-.88-1-1.31l-.72-.89c-.26-.34-.54-.67-.84-1l-.89-1a4.11,4.11,0,0,0-.29-.31c-.31-.37-.64-.72-1-1.07a.44.44,0,0,0-.09-.11c-.09-.09-.18-.19-.28-.28-.27-.3-.55-.59-.83-.88-.46-.46-.93-.93-1.41-1.38S399,44,398.57,43.6s-.72-.66-1.1-1l-1.09-.94c-.45-.38-.91-.75-1.38-1.13h0c-1.29-1-2.62-2-4-2.92-.34-.24-.67-.46-1-.68s-.69-.45-1-.67l-1.05-.63c-.35-.23-.7-.43-1.05-.63l-.85-.48a4.91,4.91,0,0,0-.44-.25c-.61-.34-1.22-.67-1.84-1-.31-.16-.62-.32-.94-.46s-.8-.4-1.2-.58l-.18-.08c-.36-.17-.73-.35-1.1-.51L378.76,31c-.6-.24-1.2-.49-1.8-.71s-1.35-.5-2-.72-1.37-.46-2.06-.67-1.39-.41-2.09-.6c-1.38-.37-2.79-.7-4.21-1l-.07,0c-.54-.11-1.09-.21-1.63-.3l-.11,0-.72-.12c-1-.17-2-.31-3.07-.42l-.37-.05-.9-.09c-.69-.07-1.37-.12-2.06-.16s-1.44-.09-2.16-.11-1.51,0-2.27,0c-2,0-4,.08-5.94.27q-.7,0-1.38.12l-1.44.17c-.48.07-1,.13-1.43.21s-.95.14-1.43.23-.82.14-1.22.22c-1,.2-2,.41-3,.64l-1.37.35-1.37.38c-.75.21-1.49.44-2.22.68h0l-1.79.6,0,0c-.61.21-1.2.43-1.79.67l-.1,0-1.62.66q-1,.42-2,.87c-.55.26-1.1.51-1.63.78s-1.15.57-1.71.87l-.07,0c-.54.29-1.08.59-1.61.9s-1.1.63-1.64,1h0l-1.52.93-.56.38c-.53.34-1,.69-1.57,1s-1.25.9-1.87,1.35-1.08.82-1.6,1.24A68.27,68.27,0,0,0,303,48.56c-.9,1-1.75,2-2.58,3.07s-1.39,1.8-2,2.74-1.15,1.64-1.69,2.48c.54-.84,1.11-1.67,1.69-2.48l.51-.06a7.73,7.73,0,0,0,2.84-.46,16.77,16.77,0,0,0,2.08-1.61c1.85-1.33,4.89-1.57,5.39-3.78a16.77,16.77,0,0,1,.24-2.27c.53-1.33,2.3-1.53,3.73-1.5.61,0,1.32.08,1.6.61a1.58,1.58,0,0,1-.06,1.24,11.63,11.63,0,0,1-4.89,6c-1.86,1.13-4.27,2-4.78,4.11.25.72,1.55.66,1.66,1.41.07.6-.69.9-1,1.44-.41.77.52,1.72,1.4,1.68a3.85,3.85,0,0,0,2.27-1.28c1.94-1.8,4-3.74,4.68-6.29.3-1.06.4-2.29,1.25-3a2.09,2.09,0,0,1,3.17,1c.84-.47,2.15-.82,2.58,0a4.2,4.2,0,0,1,.18,1c.28,1.37,2.14,2,2.34,3.36.22,1.58-1.81,2.4-3.4,2.65l-4.31.68a4.06,4.06,0,0,0-1.79.57,1.41,1.41,0,0,0-.53,1.68,4.09,4.09,0,0,0,.74.76,2.3,2.3,0,0,1-1.47,3.71c-.57,0-1.14-.19-1.71-.21-1.71-.08-3.06,1.42-3.87,2.92S305.8,72,304.43,73c-2.19,1.65-6,1.27-7,3.8a6.14,6.14,0,0,0,0,3.27,4.37,4.37,0,0,1-.39,3.21c-.63.89-2.27,1.08-2.74.08a2.41,2.41,0,0,1-.06-1.41c.25-1.58.5-3.16.74-4.73a4.66,4.66,0,0,0-.35-3.44c-1-1.34-3.14-1.22-4.4-.14a7.8,7.8,0,0,0-2.11,4.37,19.18,19.18,0,0,1-1.22,4.23h0c-.22,1.32-.4,2.67-.54,4s-.24,2.76-.29,4.16a6.14,6.14,0,0,0,.54-.51c.68-.69,2-3.62,3.24-2.18a1.08,1.08,0,0,1,0,1.33c-.37.48-1.12.58-1.4,1.11s.14,1.38.71,1.78a6.27,6.27,0,0,1,1.68,1.26c.78,1.12,0,2.81.79,4,.65,1,2,1,3.22,1.17l.4.07a5.38,5.38,0,0,1,4.62-5c4.41-1,10.2,2.66,12.68,6,2.77,3.71,4.08,9,8.32,10.84,3,1.33,7.35.85,8.83,3.82,1.32,2.66-1,5.65-1.33,8.6-.23,2,.41,3.89.56,5.84s-.44,4.24-2.21,5.06c-1,.44-2.24.39-3,1.14-1.41,1.34-.25,4.11-1.67,5.45a6.86,6.86,0,0,1-1.8.94c-3.18,1.61-3.1,6.3-1.62,9.55,0,.11.11.22.16.34a67.29,67.29,0,0,0,66.08,1.67h0a66.13,66.13,0,0,0,5.95-3.59,67.21,67.21,0,0,0,13.47-12q1.69-2,3.22-4c.52-.71,1-1.42,1.51-2.16a65.77,65.77,0,0,0,8.37-17.21,65.59,65.59,0,0,0,2.57-11.41c.2-1.51.36-3,.47-4.59a3.88,3.88,0,0,1-2.71,1.21A4.37,4.37,0,0,1,414,96.05Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.15,43.61c-1.34.79-2,2.3-3.08,3.46s-2.87,2-4.08,1a2.82,2.82,0,0,1-.92-2A5.16,5.16,0,0,1,329.8,43c.58-.94,1.46-1.68,1.95-2.68s.39-2.45-.61-2.91c-.55-.25-1.23-.16-1.71-.51-.87-.64-.25-2.15.76-2.53a7.66,7.66,0,0,1,3.2,0c3.9.25,6.77-2.3,9.7-4.43,2.28-1.64,7.14-3.59,9.78-1.91,1.05.67,1.46,2.4.47,3.16-.44.34-1.06.42-1.47.79s-.57,1.2-.85,1.81c-.74,1.57-2.87,2.15-3.55,3.75-.41,1-.23,2.16-.86,3a3.76,3.76,0,0,1-2.19,1.09l-5.09,1.2A7.55,7.55,0,0,0,337.15,43.61Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.61,126.43c-1.69,2.54-2,5.72-2.46,8.73s-1.27,6.22-3.59,8.21-6.57,1.86-7.85-.91c-.69-1.5-.33-3.28-.71-4.89-.49-2.1-2.17-3.72-3-5.73a15.77,15.77,0,0,1-.73-5.44c-.3-10.06-2.76-20.55-9.6-27.92a6.66,6.66,0,0,0-3-2.11,3.85,3.85,0,0,0-3.93,1.36,14.21,14.21,0,0,1-1.51,2.27c-1.46,1.34-4,.38-5-1.34s-.84-3.84-.68-5.81c.2-2.45.41-4.9.61-7.35a6.12,6.12,0,0,1,1.09-3.62c1.19-1.39,3.34-1.45,4.8-2.55,1.92-1.43,2.17-4.17,3.38-6.24s5-2.94,5.55-.61c4-8.57,12.85,4.16,18.11,3.2,1.52-.28,3-1,4.55-.8,2.72.38,4.12,3.37,5,6q2.29,6.42,4.6,12.85c.58,1.63,1.34,3.44,3,4.07,1.23.48,2.67.11,3.92.57,3.3,1.2,2.23,6.39-.43,8.69s-6.38,3.74-7.64,7c-.95,2.47-.2,5.36-1.22,7.8C385.2,123.59,383.66,124.85,382.61,126.43Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.14,129.22c-1.09.15-2.37-.39-3.19.34a3.53,3.53,0,0,0-.78,1.72,3.7,3.7,0,0,1-1.53,2.1,2.31,2.31,0,0,1-2.51,0,1.7,1.7,0,0,1-.35-2.35,11.16,11.16,0,0,1,.94-.76c1.44-1.36.45-3.89,1.55-5.5.64-1,1.66-1.93,2.37-2.89.54-.74.74-1.33,1.74-1.53C397.77,119.44,399.75,128.57,395.14,129.22Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.76,149.15c.56.39,1.14.76,1.72,1.12.4.26.81.5,1.22.75-.41-.25-.82-.49-1.22-.75C316.9,149.91,316.32,149.54,315.76,149.15Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286,90.47h0c0,.13,0,.25,0,.37,0,.4,0,.81,0,1.22,0-.41,0-.82,0-1.22C286,90.72,286,90.6,286,90.47Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M294.72,111c-.21-1.93.43-3.86.46-5.8,0-1.35-.07-2.76-.1-4.11a19.45,19.45,0,0,1-3.41-.48,1.06,1.06,0,0,1-.63-.32,1.26,1.26,0,0,1-.14-.72c-.09-1.51-1.54-2.51-2.85-3.27a12.14,12.14,0,0,0-2.08-1c0,.16,0,.31,0,.47a67.25,67.25,0,0,0,4.28,21.35,64.27,64.27,0,0,0,4.11,8.82c.66,1.22,1.39,2.42,2.14,3.61.94,1.45,1.92,2.88,3,4.25s2,2.61,3.12,3.85q2.25,2.57,4.76,4.9c1.48,1.38,3,2.69,4.63,3.94-3.67-9.86-7.13-19.93-13.41-28.32C296.93,115.92,295,113.68,294.72,111Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.2,98.44l-.4-.07c-1.19-.13-2.57-.19-3.22-1.17-.75-1.14,0-2.83-.79-4A6.27,6.27,0,0,0,289.11,92c-.57-.4-1.06-1.17-.71-1.78s1-.63,1.4-1.11a1.08,1.08,0,0,0,0-1.33c-1.21-1.44-2.56,1.49-3.24,2.18a6.14,6.14,0,0,1-.54.51h0c0,.13,0,.25,0,.37,0,.4,0,.81,0,1.22s0,.81,0,1.21,0,.32,0,.64,0,1,0,1.33a12.14,12.14,0,0,1,2.08,1c1.31.76,2.76,1.76,2.85,3.27a1.26,1.26,0,0,0,.14.72,1.06,1.06,0,0,0,.63.32,19.45,19.45,0,0,0,3.41.48",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.08,101.05c0,1.35.12,2.76.1,4.11,0,1.94-.67,3.87-.46,5.8.31,2.72,2.21,5,3.86,7.15,6.28,8.39,9.74,18.46,13.41,28.32h0c.69.54,1.38,1,2.08,1.55s1.11.79,1.68,1.17,1.14.76,1.72,1.12c.4.26.81.5,1.22.75-.05-.12-.11-.23-.16-.34-1.48-3.25-1.56-7.94,1.62-9.55a6.86,6.86,0,0,0,1.8-.94c1.42-1.34.26-4.11,1.67-5.45.8-.75,2.05-.7,3-1.14,1.77-.82,2.35-3.1,2.21-5.06s-.79-3.89-.56-5.84c.35-3,2.65-5.94,1.33-8.6-1.48-3-5.8-2.49-8.83-3.82-4.24-1.87-5.55-7.13-8.32-10.84-2.48-3.32-8.27-7-12.68-6a5.38,5.38,0,0,0-4.62,5",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.16,73.68c1.26-1.08,3.43-1.2,4.4.14a4.66,4.66,0,0,1,.35,3.44c-.24,1.57-.49,3.15-.74,4.73a2.41,2.41,0,0,0,.06,1.41c.47,1,2.11.81,2.74-.08a4.37,4.37,0,0,0,.39-3.21,6.14,6.14,0,0,1,0-3.27c1.07-2.53,4.85-2.15,7-3.8,1.37-1,2-2.74,2.78-4.24s2.16-3,3.87-2.92c.57,0,1.14.23,1.71.21a2.3,2.3,0,0,0,1.47-3.71,4.09,4.09,0,0,1-.74-.76,1.41,1.41,0,0,1,.53-1.68,4.06,4.06,0,0,1,1.79-.57l4.31-.68c1.59-.25,3.62-1.07,3.4-2.65-.2-1.38-2.06-2-2.34-3.36a4.2,4.2,0,0,0-.18-1c-.43-.87-1.74-.52-2.58,0a2.09,2.09,0,0,0-3.17-1c-.85.7-.95,1.93-1.25,3-.71,2.55-2.74,4.49-4.68,6.29a3.85,3.85,0,0,1-2.27,1.28c-.88,0-1.81-.91-1.4-1.68.28-.54,1-.84,1-1.44-.11-.75-1.41-.69-1.66-1.41.51-2.1,2.92-3,4.78-4.11a11.63,11.63,0,0,0,4.89-6,1.58,1.58,0,0,0,.06-1.24c-.28-.53-1-.61-1.6-.61-1.43,0-3.2.17-3.73,1.5a16.77,16.77,0,0,0-.24,2.27c-.5,2.21-3.54,2.45-5.39,3.78a16.77,16.77,0,0,1-2.08,1.61,7.73,7.73,0,0,1-2.84.46l-.51.06c-.58.81-1.15,1.64-1.69,2.48s-1.07,1.7-1.58,2.57a67.1,67.1,0,0,0-5.83,13c-.52,1.6-1,3.21-1.38,4.86s-.74,3.31-1,5a19.18,19.18,0,0,0,1.22-4.23A7.8,7.8,0,0,1,290.16,73.68Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.35,97.7a6.53,6.53,0,0,1-2.71,1.22,4.37,4.37,0,0,1-3.6-2.87,32.83,32.83,0,0,1-1.24-4.7,3.11,3.11,0,0,0-1.42-2.11,11.85,11.85,0,0,0-1.69-.39c-2-.59-2.54-3.37-4.42-4.23a6.51,6.51,0,0,0-1.9-.4c-2.52-.3-5.13-1.17-6.72-3.15a12.52,12.52,0,0,0-1.55-1.92,1.87,1.87,0,0,0-2.28-.21l1.58,3.18a8.63,8.63,0,0,0,1.76,2.66,2.87,2.87,0,0,0,3,.63,2,2,0,0,1,1-.35,1.11,1.11,0,0,1,.65.42c1.37,1.52.92,4-.42,5.6a12.91,12.91,0,0,1-5.22,3.11,4.07,4.07,0,0,1-2.13.41c-1.32-.24-2-1.68-2.4-3-.87-2.85-1.28-5.95-3.05-8.36A10.31,10.31,0,0,1,386,80.94c-.36-1-.27-2.07-.85-2.92s-1.86-1.39-1.95-2.46a2,2,0,0,1,1.25-1.72c.68-.33,1.45-.43,2.15-.71.28-.12.59-.32.6-.62,0-.45-.62-.63-.78-1s.31-.91.51-1.37c.44-1-.65-2.1-1.7-2.52s-2.31-.74-2.8-1.76a5.59,5.59,0,0,1-.34-1.52,3.36,3.36,0,0,0-2.5-2.75A2.19,2.19,0,0,0,377,63.8a9.34,9.34,0,0,0,.95,1.93c.29.66.21,1.64-.47,1.85-1.12.34-2.2-1.7-3.13-1,.38,1.31.75,2.62,1.14,3.94-1.47.74-3.23-.61-3.86-2.14s-.65-3.27-1.39-4.74-2.76-2.58-4-1.53c-.06,1.89,2.44,2.66,3.55,4.19a2.57,2.57,0,0,1-.5,3.61c-1.17.7-3-.52-2.59-1.81.16-.45.53-.82.57-1.3s-.45-1.07-.91-1.46l-2.14-1.8a4.57,4.57,0,0,0-1.52-.95c-1.47-.43-2.94.76-3.72,2.07s-1.21,2.87-2.29,4a4.18,4.18,0,0,1-5.92,0c-1.46-1.67-.71-4.8,1.43-5.41.81-.22,1.83-.2,2.26-.91.74-1.27-1.39-2.89-.65-4.16.56-1,2.05-.54,3.14-.87s1.68-1.41,2.32-2.35,1.62-1.86,2.72-1.62a3.45,3.45,0,0,1,.12-1.94,1.19,1.19,0,0,1,1.63-.59,2,2,0,0,0,1.05,2.58,5.71,5.71,0,0,0,3.1.23c1.05-.13,2.36-.51,2.44-1.56a3.85,3.85,0,0,1,0-1c.46-1.24,2.76.47,3.64-.53.52-.52-.05-1.45-.76-1.62a7.88,7.88,0,0,0-2.16.11c-.73,0-1.61-.35-1.64-1.08s.76-1.22.85-1.93c.14-1.19-1.89-1.5-2.6-.53s-.46,2.3-.24,3.48.33,2.58-.55,3.41c-.37.57-1.34.27-1.66-.33a4.92,4.92,0,0,1-.31-2,1.71,1.71,0,0,0-1-1.63,3.66,3.66,0,0,0-1.42.16c-1.85.22-3.14-2.17-2.55-3.94s2.26-2.92,3.89-3.82c1.19-.66,2.67-1.28,3.85-.61.55.31.94.84,1.48,1.16.94.56,2.1.35,3.17.37A7.49,7.49,0,0,1,377,43.5c.47.44.92,1.16.55,1.69s-1.57.67-1.36,1.32A2.31,2.31,0,0,0,379,44.64a1.94,1.94,0,0,1,1.12,1.58,3.46,3.46,0,0,1,5.06.41,4.48,4.48,0,0,0,.93,1.21c.43.27,1.18.14,1.23-.36a1,1,0,0,0-.09-.47c-.25-.73-.52-1.44-.77-2.15,1-.54,2.16.29,2.83,1.19,2.49,3.33,4.27,1.33,7.78,1.87,2.38.36,3.42,1.89,4.76,3.73C406,57.31,411.42,62,415.16,67.88c.39.61.76,1.24,1.1,1.88h0q.48,1.28.9,2.58c.28.86.55,1.73.8,2.61a56.21,56.21,0,0,1,1.61,6.6s.47,3.81.58,5c.09,1,.17,1.89.23,2.85s.08,1.92.08,2.89Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M467.06,462.43c0,.14-97.19.26-217,.26s-217.07-.12-217.07-.26,97.17-.26,217.07-.26S467.06,462.28,467.06,462.43Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Browsers--inject-62"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 359.79,
    y: 169.93,
    width: 104.89,
    height: 104.89,
    rx: 5.4,
    transform: "translate(-49.97 146.49) rotate(-19.02)",
    style: {
      fill: "#474af0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.89,194.36A32.36,32.36,0,0,0,400,196l-.14-.22a4,4,0,0,0,0-2.63,4.07,4.07,0,1,0-4.15,5.35,32.48,32.48,0,1,0,8.19-4.11Zm-10.84,1a3.11,3.11,0,0,1,5.9-2,3.17,3.17,0,0,1,.08,1.64,2.27,2.27,0,0,0-1.74-.13,2.23,2.23,0,0,0-1.47,2.59A3.12,3.12,0,0,1,393.05,195.4Zm36.8,49.32L426,242.43a.84.84,0,0,0-1.26.83l.57,4.21a24.47,24.47,0,0,1-30.39-7.94l1.93-2.84a.75.75,0,0,0-.81-1.14l-3.05.78a24.53,24.53,0,0,1,7.43-30.94l3.41,2.37A.74.74,0,0,0,405,207l-.6-4a25.79,25.79,0,0,1,2.7-1.09,24.55,24.55,0,0,1,27.79,9l-2.42,3.2a.64.64,0,0,0,.62,1l3.9-.69a28.48,28.48,0,0,1,1.21,2.95A24.59,24.59,0,0,1,429.85,244.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.34,205.82s-4,4.49-8.77,11l-.26-2.56a36.38,36.38,0,0,0-3.11,3.08,7.54,7.54,0,0,0-2.18.33l-5.16-5.57,2.36,7a8.19,8.19,0,0,0-2.22,2.85l-3.62.51s2,2,2.87,2.76a7.8,7.8,0,0,0,.41,2.68,1.8,1.8,0,0,0,.08.21l-5.61,5.4,7.35-2.62a.46.46,0,0,0,.07.07,50.37,50.37,0,0,0-5.18,13.49s3.56-3.87,7.9-9.63l.31,2s3.17-3.19,3-3.37l-.07-.05a8.07,8.07,0,0,0,2.35-.41l.26-.1,5.69,5.25-3-7a7.77,7.77,0,0,0,1.27-1.54l4-.39s-1.93-2.17-2.79-2.92a8,8,0,0,0-.31-3.35l5.62-4.88-6.7,2A51.78,51.78,0,0,0,426.34,205.82Zm-14.21,13.12a6.7,6.7,0,0,1,4-.1,115.17,115.17,0,0,0-6.89,10.89,6.56,6.56,0,0,1-1.31-2.27A6.73,6.73,0,0,1,412.13,218.94Zm1.21,13a117.52,117.52,0,0,0,6.6-10.28,7,7,0,0,1,.72,1.48,6.73,6.73,0,0,1-4.24,8.52A6.66,6.66,0,0,1,413.34,232Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "382.28 177.23 377.57 282.73 372.59 268.29 373.04 180.41 382.28 177.23",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.3,
    y: 302.05,
    width: 71.82,
    height: 71.82,
    rx: 5.4,
    transform: "translate(-38.66 624.2) rotate(-73.55)",
    style: {
      fill: "#474af0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 362.3,
    y: 302.05,
    width: 71.82,
    height: 71.82,
    rx: 5.4,
    transform: "translate(-38.66 624.2) rotate(-73.55)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M390.73,337.54a8.39,8.39,0,1,0,8.85-7.91A8.39,8.39,0,0,0,390.73,337.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.05,334.63a11.59,11.59,0,0,1,11.7-8.17c.31,0,.61.05.91.09v0l19.12,1.07a23.15,23.15,0,0,0-38.11-4.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.51,330.07a11.53,11.53,0,0,1,0,15.91l-10,15.13.35,0a23.15,23.15,0,0,0,23.3-30.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.46,349.34a11.49,11.49,0,0,1-3,.22c-5.42-.3-9.51-4.23-11-9.29l-7.91-14.69a23.17,23.17,0,0,0,14.43,35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.02,
    y: 51.01,
    width: 76.5,
    height: 76.5,
    rx: 5.4,
    transform: "translate(-14.56 38.64) rotate(-11.89)",
    style: {
      fill: "#474af0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.73,69.88s-2.7,3.9-2,5.89,3.32,1.63,3.86,1.61,3.8-.64,3.8-.64a3.14,3.14,0,0,1-.41,2.65,56.94,56.94,0,0,1-4.24,4.47l.34,3.38s-3.57-.33-3.48,1.61,3.14,4.23,6,3.74,4.18-3,6.1-2.75a16.47,16.47,0,0,1,4.3,1.38s.17,1.92-2.61,2.16a12.34,12.34,0,0,1-8.7,4.92s3.16,4.31,11.89,1.42c7.69-2.55,7.59-9.89,7.46-11.61a.35.35,0,0,1,.52-.33,2.9,2.9,0,0,1,.82,1.14l-1.19-8.66a.67.67,0,0,1,1.17-.53,3.21,3.21,0,0,1,.49.9,14.55,14.55,0,0,0-6-10,.5.5,0,0,1,.31-.9,6.6,6.6,0,0,1,2.72.47s-8.13-6-7.5-6.38S197.2,67.34,201.06,79c0,0,.14-2,.86-2,.15,0,.65.36,1.16,2.25A29.66,29.66,0,0,1,203,94.76h0A26.16,26.16,0,0,1,152.75,80s-1.85-6.62,1.3-9.29c0,0,.63,4,3.19,4.23l6.37-1.25A7,7,0,0,1,169.73,69.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.02,
    y: 342.38,
    width: 120.02,
    height: 120.02,
    rx: 5.4,
    style: {
      fill: "#474af0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.82,368.5c-7.11-6.11-22-.84-27.38,1.36a35.16,35.16,0,0,0-16.46,3c-7.29,3.24-15.69,9.61-18.72,22.13l16.68-13.65s-19.42,18-24.07,36.61,2.45,20.23,6.28,21,14.48-1.36,19.13-4.91c0,0,16.4,7.94,31.44-.53s14.77-18.85,14.77-18.85H154.27s-5.1,8-14.22,7.65c-13.94-.56-15-13.95-15-13.95l48.66,0v-5.33a34.05,34.05,0,0,0-3.53-15.14C171.68,385.49,177.52,375.12,169.82,368.5ZM106.5,431.76c-5.69-4.43,0-15.49,0-15.49a37.87,37.87,0,0,0,5.53,8.07,95.85,95.85,0,0,0,9.64,8.22S112.19,436.19,106.5,431.76Zm19.69-31.83a14.26,14.26,0,1,1,28.51,0Zm36.18-22.07a33.12,33.12,0,0,0-9.15-5.56c4.47-1.89,12.39-4.21,16.19.91,3,4.08,1.42,8.83-.6,12.27A31.62,31.62,0,0,0,162.37,377.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.69,416.36c5.37-6.13,8.65-13.88,10.31-21.86,2-9.39,1.76-19.13,1.1-28.67a18.11,18.11,0,0,1,.88-7.31c3.38-9.53,12.46-8.49,20.1-7.67a135.56,135.56,0,0,0,63.6-8.51H81.22A5.22,5.22,0,0,0,76,347.55Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.05,196.42c-2,4.75-7.94,7.27-9,12.3-.88,4.16,1.95,8.89-.26,12.53-2,3.36-7,3.42-9.87,6.15-1.8,1.74-2.48,4.32-2.76,6.8-.33,3-.13,6.18,1.64,8.59a9.8,9.8,0,0,0,7.19,3.65,20.57,20.57,0,0,0,8.15-1.33c7.3-2.46,14.09-6.84,18.66-13.05s6.72-14.36,5-21.87-7.68-14.1-15.19-15.85",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.27,242.92s-.06-.13-.1-.4a7.2,7.2,0,0,1-.15-1.17,14.52,14.52,0,0,1,.3-4.32,16.85,16.85,0,0,1,2.5-5.93,16,16,0,0,1,2.51-2.89,21.22,21.22,0,0,1,3.31-2.4,12.93,12.93,0,0,0,3.08-2.49A4.89,4.89,0,0,0,135,220a16,16,0,0,0-.63-3.29,6.72,6.72,0,0,1-.12-3,6.24,6.24,0,0,1,2.3-3.66,5.45,5.45,0,0,1,1-.61,1.66,1.66,0,0,1,.4-.13,14.07,14.07,0,0,0-1.29.9,6.23,6.23,0,0,0-2.06,3.57,6.49,6.49,0,0,0,.18,2.87,16.24,16.24,0,0,1,.69,3.39,5.38,5.38,0,0,1-1.37,3.61,13.26,13.26,0,0,1-3.19,2.6,17.36,17.36,0,0,0-5.7,5.12,16.83,16.83,0,0,0-2.54,5.74,16.22,16.22,0,0,0-.46,4.23C122.24,242.36,122.32,242.91,122.27,242.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.6,181.71a6.74,6.74,0,0,1,3.89-12.26c3.15,0,5.86,2.17,8.91,2.93,2.4.6,4.91.32,7.38.38s5.11.57,6.81,2.36c2.12,2.23,2.19,5.8,4.15,8.18,1.39,1.7,3.55,2.54,5.31,3.86a11.67,11.67,0,0,1,1.16,17.67c-1.17,1.15-2.63,2.11-3.32,3.6-1,2.27,0,5.28-1.64,7.21s-5,1.76-6.16,3.93c-.48.87-.6,2.09-1.52,2.48a2.56,2.56,0,0,1-2.19-.51l-9.17-5.43",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.27,225.81l-9.42,1.26a22.88,22.88,0,0,0-9.37,5.89l-26.07,27.16-6.61-40.26-13.51,1.73,4.06,48a15.27,15.27,0,0,0,14.55,14.15c.36,0,.72,0,1.08,0a16,16,0,0,0,10.66-4.93l17.09-14.9",
    style: {
      fill: "#474af0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.89,225.17a5,5,0,0,1-.48-2,5.12,5.12,0,0,1,0-2.08,4.77,4.77,0,0,1,.48,2A4.93,4.93,0,0,1,89.89,225.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.86,225.13a11,11,0,0,1-.4-4.36,5.61,5.61,0,0,1,.42,2.16A5.24,5.24,0,0,1,93.86,225.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8,224.72a6.69,6.69,0,0,1-.46-2.41,7,7,0,0,1,0-2.45,6.56,6.56,0,0,1,.46,2.41A7,7,0,0,1,97.8,224.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.09,188.88c.26.47,8.06,33.35,8.06,33.35L101,223.56l-7-28.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.15 222.23 117.86 221.42 109.95 189.02 107.88 188.97 116.15 222.23",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.27,196.37a.8.8,0,0,1-.65.91.78.78,0,0,1-.9-.65.79.79,0,0,1,.65-.91A.78.78,0,0,1,102.27,196.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.12,220.09l-.44-4.66,6.39-2.94-2.78-5.91a5.25,5.25,0,0,0-7.4-2.2l-2.54,1.52a7.42,7.42,0,0,0-3.5,5,97.87,97.87,0,0,0-1.08,10.66",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,225.37c-12.06,1.35-16,10.36-21.6,18.42l-8.13,15,15.5,5.14L133.66,291l-7.12,22,55.56-3.28-4.5-20.85,3.16-23.8,3-19.85a14.77,14.77,0,0,0-8.95-16c-7.48-2.92-7.68-3.47-13.63-3.73-1.89-.08-10.65-.45-12.18-.07",
    style: {
      fill: "#474af0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.68,290.37a12.2,12.2,0,0,0,.15-1.63c0-1.15.13-2.65.22-4.47.16-3.77.34-9,.52-14.73s.3-11,.37-14.74c0-1.82,0-3.32.05-4.47a9.53,9.53,0,0,0-.05-1.64,9,9,0,0,0-.15,1.63c-.06,1.14-.13,2.65-.22,4.46-.16,3.77-.35,9-.52,14.74s-.31,11-.37,14.74c0,1.82,0,3.33-.05,4.47A8.38,8.38,0,0,0,133.68,290.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.31,424.93l-.2-9.9,19-6.74.79,13.78-1.07.51C61,424.83,41.42,433.7,37.76,434,33.68,434.41,47.31,424.93,47.31,424.93Z",
    style: {
      fill: "#474af0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.76,429.82s-4.65,3.66-3.64,4.26,21.18-7.61,29.76-12l-.19-.39-23.45,9.78S41.8,429.44,40.76,429.82Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67,421.56l-.29.15-.85.41-3.15,1.45c-2.68,1.2-6.39,2.81-10.53,4.5s-7.92,3.13-10.67,4.14l-3.27,1.18-.89.3a1.14,1.14,0,0,1-.32.09l.31-.13.87-.35,3.24-1.24c2.74-1.05,6.51-2.52,10.64-4.21s7.86-3.27,10.55-4.43L65.78,422l.87-.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.36,431.73a7.9,7.9,0,0,0-1.22-1.29,7.63,7.63,0,0,0-1.6-.78,2.56,2.56,0,0,1,1.73.6A2.53,2.53,0,0,1,43.36,431.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5,427s-.41-.15-.84-.46-.73-.58-.7-.63.41.14.84.45S47.53,426.91,47.5,427Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.62,425.63c0,.06-.38,0-.79-.17s-.74-.31-.72-.37.38,0,.8.16S48.64,425.57,48.62,425.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.84,423.59c0,.06-.36.28-.87.49a2.14,2.14,0,0,1-1,.28c0-.06.36-.28.87-.49A2.31,2.31,0,0,1,48.84,423.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.68,422.29a2,2,0,0,1-.91.72,1.94,1.94,0,0,1-1.12.29,6.29,6.29,0,0,1,1-.5A6,6,0,0,1,48.68,422.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.27,425.67a3.66,3.66,0,0,1-1.14.45,7.06,7.06,0,0,1-1.31.23,3.65,3.65,0,0,1-.81,0,.7.7,0,0,1-.43-.24.51.51,0,0,1,0-.53,2.26,2.26,0,0,1,2.82-.44,2.21,2.21,0,0,1,.68.61c.13.18.17.29.16.3a3.49,3.49,0,0,0-.92-.76,2.23,2.23,0,0,0-1.22-.24,2,2,0,0,0-1.32.65c-.12.2,0,.39.28.42a3.76,3.76,0,0,0,.75,0,8.35,8.35,0,0,0,1.29-.18C45.82,425.81,46.26,425.63,46.27,425.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,425.84a1.17,1.17,0,0,1-.45-.73,1.91,1.91,0,0,1,0-1,1.23,1.23,0,0,1,.71-1,.48.48,0,0,1,.56.38,1.49,1.49,0,0,1,0,.59,4.23,4.23,0,0,1-.26.9,1.92,1.92,0,0,1-.46.73s.14-.3.31-.79a3.88,3.88,0,0,0,.19-.87c.06-.3,0-.78-.31-.71s-.47.49-.55.78a2,2,0,0,0,0,.87A3.8,3.8,0,0,0,46,425.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.63,416.87s-.52.16-1.28.58A6.08,6.08,0,0,0,61,419.78a6.15,6.15,0,0,0-.76,3.24c0,.87.22,1.39.18,1.4a1.42,1.42,0,0,1-.15-.36,5.31,5.31,0,0,1-.19-1,5.81,5.81,0,0,1,.72-3.36,6,6,0,0,1,2.49-2.37,5.52,5.52,0,0,1,1-.37A1.2,1.2,0,0,1,64.63,416.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.81,410.27a32.18,32.18,0,0,1,1.63,3.56,33.72,33.72,0,0,1,1.42,3.66,32.93,32.93,0,0,1-1.63-3.57A34.06,34.06,0,0,1,59.81,410.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.49,423.71A10.93,10.93,0,0,1,55,425a10.67,10.67,0,0,1-2.67.84c0-.06,1.16-.46,2.58-1.06S57.46,423.65,57.49,423.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,422.3c.06,0,0,.28,0,.59s0,.58,0,.6-.2-.24-.19-.61S60.89,422.27,61,422.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.59,420.14c.06,0,0,.26-.08.52s-.25.45-.31.42,0-.25.09-.51S61.53,420.12,61.59,420.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.16,418.64c0,.07-.23.16-.45.36s-.35.41-.41.39,0-.33.26-.57S63.15,418.58,63.16,418.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.34,417.75c0,.05,0,.18-.14.3s-.26.17-.3.12,0-.18.14-.29S64.3,417.7,64.34,417.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.49,313.83l-55.72,1a17.9,17.9,0,0,0-17.43,15.71l-11.05,89.8H69.55l9.25-77.57h43.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.67,414.67c0,.14,6.63.3,14.8.35s14.67-.15,14.81-.17c.94-.09-6.62-.3-14.8-.35S39.67,414.53,39.67,414.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.8,342.81c22.24-7.36,6.3-33.13,6.3-33.13l-84.83,4.95a14.06,14.06,0,0,0-14.16,14.06l.31,2.26c0,7.77,6,11.81,13.76,11.81l78.62.05",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.65,311h-.28l-.81,0-3.14.12-11.52.55-38,2c-1.86.08-3.69.23-5.49.26s-3.6.1-5.35.2-3.48.22-5.16.39a19.45,19.45,0,0,0-4.89,1,11.75,11.75,0,0,0-4.08,2.47,10.38,10.38,0,0,0-2.47,3.75,17.57,17.57,0,0,0-1,4.06,27,27,0,0,0-.27,3.83A15.53,15.53,0,0,0,81.49,336,10.54,10.54,0,0,0,84.54,340a8.38,8.38,0,0,0,2.77,1.49c.69.2.7.14,0-.1a8.66,8.66,0,0,1-2.68-1.54,10.48,10.48,0,0,1-2.91-3.89,15.41,15.41,0,0,1-1.2-6.35,28.09,28.09,0,0,1,.3-3.78,18.15,18.15,0,0,1,1-4,9.84,9.84,0,0,1,2.39-3.58,11.41,11.41,0,0,1,3.92-2.36A19.09,19.09,0,0,1,93,315c1.67-.17,3.39-.28,5.13-.38s3.53-.17,5.33-.19,3.65-.18,5.5-.26l38-2.12,11.51-.7,3.13-.22.82-.07A.72.72,0,0,0,162.65,311Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.42,181.11a3.25,3.25,0,0,1,2.91,3.3h0l-1.84,44c-.07,5.19-9.5,11.33-15.06,11.22h0c-5.61-.12-4.43-6.1-4-11a73.84,73.84,0,0,0-.14-11.31s-7.09-1.18-8.56-10.43c-.73-4.61-.5-12.16-.11-18.33a9.77,9.77,0,0,1,10.78-9.11Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,194.52a1.18,1.18,0,0,0,1.15,1.19,1.13,1.13,0,0,0,1.22-1.07,1.2,1.2,0,0,0-1.14-1.2A1.14,1.14,0,0,0,140,194.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.21,192.45c.15.16,1-.51,2.33-.51s2.21.65,2.35.49-.08-.35-.49-.65a3.33,3.33,0,0,0-1.88-.58,3.14,3.14,0,0,0-1.85.6C139.27,192.1,139.14,192.38,139.21,192.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.47,194.52a1.18,1.18,0,0,0,1.15,1.19,1.13,1.13,0,0,0,1.22-1.07,1.2,1.2,0,0,0-1.14-1.2A1.14,1.14,0,0,0,152.47,194.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.77,192.69c.15.15,1-.51,2.33-.51s2.21.64,2.35.49-.08-.35-.49-.65a3.33,3.33,0,0,0-1.88-.58,3.14,3.14,0,0,0-1.85.6C151.83,192.34,151.7,192.62,151.77,192.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.14,202.16a8.62,8.62,0,0,0-2.08-.37c-.33,0-.63-.1-.69-.32a1.63,1.63,0,0,1,.22-1c.3-.79.63-1.62,1-2.48a43.52,43.52,0,0,0,2.17-6.5,42.9,42.9,0,0,0-2.69,6.31c-.32.87-.63,1.7-.92,2.5a1.89,1.89,0,0,0-.17,1.28.81.81,0,0,0,.54.47,2,2,0,0,0,.55.08A7.86,7.86,0,0,0,147.14,202.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.25,217.28a23.56,23.56,0,0,0,12.4-3.31s-3,6.36-12.27,5.5Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.68,205.24a2.27,2.27,0,0,1,2.06-.85,2.08,2.08,0,0,1,1.45.78,1.32,1.32,0,0,1,.1,1.52,1.53,1.53,0,0,1-1.67.42,4.81,4.81,0,0,1-1.64-1,1.63,1.63,0,0,1-.36-.38.42.42,0,0,1,0-.48",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.89,203.05c-.2,0-.21,1.37-1.39,2.36s-2.67.83-2.68,1,.33.27,1,.29a3.48,3.48,0,0,0,2.23-.78,3,3,0,0,0,1.08-2C151.14,203.38,151,203,150.89,203.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.2,190.45c.12.35,1.4.18,2.9.37s2.71.58,2.91.27c.09-.15-.12-.47-.61-.81a5,5,0,0,0-2.16-.75,4.88,4.88,0,0,0-2.27.26C151.42,190,151.14,190.29,151.2,190.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.68,188.75c.23.29,1.11,0,2.17,0s2,.19,2.16-.11,0-.44-.45-.71a2.94,2.94,0,0,0-1.75-.48,3,3,0,0,0-1.73.58C139.71,188.31,139.58,188.61,139.68,188.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.58,188.52c1.33-4.46,2.4-5.82,7-7.34,2.27,10,11.23,6.66,16.28,7.48a3.36,3.36,0,0,1,1.49.48c.78.57.84,1.7.83,2.67a35,35,0,0,0,.68,8.18,13.43,13.43,0,0,0,3.95,7.06c3.06-6.44,3.36-13.92,2-20.91-.55-2.86-1.5-5.85-3.77-7.66a12.87,12.87,0,0,0-5.78-2.2c-5.06-.93-12.93-7.58-17.87-6.14a8.49,8.49,0,0,0-6.24,5.87,15,15,0,0,0,.67,10.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.54,323.06a2.11,2.11,0,0,1-.77.38,7.84,7.84,0,0,1-2.3.47,9,9,0,0,1-9.63-9.88,8.2,8.2,0,0,1,.52-2.29,2.58,2.58,0,0,1,.4-.76,18.39,18.39,0,0,0-.56,3.08,8.92,8.92,0,0,0,9.25,9.48A15.69,15.69,0,0,0,175.54,323.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,227.46v-5.61a2.5,2.5,0,0,1,2.42-2.5l19.51-.62a2.49,2.49,0,0,1,2.57,2.42l.28,9.11-11.4,10.46-11.08,1.15-1.89-6.14Z",
    style: {
      fill: "#474af0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.29,228.08a22.91,22.91,0,0,0-6.51,8.94l-13.31,32.06L140,238.34l-12.21,2.43a5.12,5.12,0,0,0-3.91,6.49l11.91,40.34c3.45,6.91,13,9.54,20.26,6.83l1-.39a16,16,0,0,0,8.07-8.53l10.35-20.18,6.91-15.78c.14-.33.27-.66.4-1,3.27-9.11-3-18.9-12.62-20.34l-.81-.13",
    style: {
      fill: "#474af0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.8,275.84a14.55,14.55,0,0,1-.8-3.5,15,15,0,0,1-.35-3.57",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.25,240.9s-.4.09-1.09.42a4.2,4.2,0,0,0-2.07,2.48,5.75,5.75,0,0,0-.28,2.36,14.32,14.32,0,0,0,.7,2.78c.6,2,1.28,4.27,2,6.77,1.5,5,3.28,11,5.26,17.64l3.11,10.42a17.35,17.35,0,0,0,6.71,9.07,15.47,15.47,0,0,0,10.92,2.59,14.08,14.08,0,0,0,9-5.29,27.73,27.73,0,0,0,2.52-4.33c.75-1.46,1.49-2.87,2.2-4.24,1.43-2.73,2.76-5.27,4-7.6L176,263l1.6-3,.42-.77c.1-.17.16-.26.17-.25l-.12.27c-.1.21-.22.47-.38.79-.36.73-.87,1.74-1.51,3-1.34,2.65-3.26,6.42-5.63,11.06l-3.91,7.63L164.45,286a27.06,27.06,0,0,1-2.54,4.41,14.57,14.57,0,0,1-9.29,5.51,15.92,15.92,0,0,1-11.28-2.67,17.85,17.85,0,0,1-6.91-9.35q-1.6-5.43-3.08-10.43l-5.16-17.67c-.73-2.51-1.38-4.79-2-6.8a13.69,13.69,0,0,1-.67-2.84,5.87,5.87,0,0,1,.34-2.44,4.21,4.21,0,0,1,2.22-2.51A3.67,3.67,0,0,1,127.25,240.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,238.34a2.37,2.37,0,0,1,.24.58c.16.44.35,1,.59,1.7.52,1.55,1.22,3.68,2.09,6.29l6.68,20.8c.11.33.22.67.31,1l-.48,0,8.15-19.53c1.05-2.43,1.9-4.42,2.52-5.86.28-.65.52-1.17.7-1.58a2.93,2.93,0,0,1,.28-.54,3.53,3.53,0,0,1-.18.58l-.62,1.62-2.36,5.92c-2.07,5.05-4.88,11.93-8,19.59l-.27.66-.22-.68c-.1-.31-.21-.65-.31-1-2.55-8.11-4.85-15.45-6.55-20.85-.8-2.63-1.45-4.77-1.92-6.33-.21-.71-.37-1.28-.5-1.73A2.63,2.63,0,0,1,140,238.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.2,231c0,.09-.83,0-2.13.14a11.5,11.5,0,0,0-8.41,5.07c-.73,1.09-1,1.86-1.11,1.82a4.78,4.78,0,0,1,.8-2,10.57,10.57,0,0,1,8.69-5.25A5.1,5.1,0,0,1,174.2,231Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.79,227.57a16.78,16.78,0,0,1-.08-4.14,17.19,17.19,0,0,1,.45-4.13,16.62,16.62,0,0,1,.07,4.15A16.88,16.88,0,0,1,147.79,227.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153,227.07a11.64,11.64,0,0,1-.45-3.91,12,12,0,0,1,.34-3.92,19.55,19.55,0,0,1,.18,3.91A21.53,21.53,0,0,1,153,227.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.18,227a12.53,12.53,0,0,1-.35-4,12.37,12.37,0,0,1,.41-4,19,19,0,0,1,.11,4A19.68,19.68,0,0,1,158.18,227Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.68,226.74a15,15,0,0,1-.27-3.92,15.27,15.27,0,0,1,.24-3.91,14.94,14.94,0,0,1,.28,3.91A15.45,15.45,0,0,1,163.68,226.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.48,270.17a12.92,12.92,0,0,1,1-10.74,37.79,37.79,0,0,0-1.17,5.31A38,38,0,0,0,106.48,270.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.46,238.86s-.69-7.66-1.2-11.61-2.93-3.49-3.15-5.63-1.2-2-1.2-2c-1.17-.42-.9,2.76-.9,2.76s-9.43-2.28-10.14-2.57a1.19,1.19,0,0,0-1.43,1.58c.15.37,5.41,2.57,5.41,2.57s-4.32,4.16-4.41,5.92,5.69,5.85,5.69,5.85l.12,5.21Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.1,226.23c-.07,0-.19-.21-.57-.38s-1-.38-1.62-.66c-1.27-.56-2.25-1.12-2.19-1.26a6.36,6.36,0,0,1,2.4.78,9.53,9.53,0,0,1,1.61.83C130.15,225.84,130.18,226.23,130.1,226.23Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.89,228.38c-.1.11-.91-.53-2-1.19S124,226,124,225.9a4,4,0,0,1,2.19.85C127.31,227.45,128,228.28,127.89,228.38Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.45,230.05a5.41,5.41,0,0,1-2.18-.79c-1.14-.57-2-1.14-1.94-1.27a5.53,5.53,0,0,1,2.18.8C125.65,229.36,126.52,229.92,126.45,230.05Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.46,238.64a16.8,16.8,0,0,1-.42-2.82c-.21-1.74-.45-4.16-.91-6.79a16.81,16.81,0,0,0-1-3.58,2.74,2.74,0,0,0-.91-1.2,11,11,0,0,0-1.19-.75c-1.55-.78-2.6-1.12-2.56-1.21s.28,0,.75.16a14.49,14.49,0,0,1,2,.72,8.57,8.57,0,0,1,1.28.73,3.21,3.21,0,0,1,1.1,1.35,15.71,15.71,0,0,1,1,3.69,63.44,63.44,0,0,1,.77,6.85A15.38,15.38,0,0,1,138.46,238.64Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.57,208.3a2.6,2.6,0,0,1,.18-.65l.58-1.84a36.8,36.8,0,0,0,1.6-6.88,17.55,17.55,0,0,0-.07-4.84,13.19,13.19,0,0,0-2-5.12,9.35,9.35,0,0,0-4.62-3.77c-2-.71-4.24-.65-6.53-.77a10.55,10.55,0,0,1-6.41-2.08,5.89,5.89,0,0,1-1.74-2.76c-.33-1-.53-2-.89-2.9a5.48,5.48,0,0,0-4-3.32,8.88,8.88,0,0,0-4.74.14,6.1,6.1,0,0,0-3.21,2.16,4.46,4.46,0,0,0-.83,2.8,3.63,3.63,0,0,0,.52,1.8c.23.37.4.53.38.55a1.93,1.93,0,0,1-.47-.49,3.66,3.66,0,0,1-.64-1.84,4.65,4.65,0,0,1,.8-3,6.37,6.37,0,0,1,3.34-2.35,9.22,9.22,0,0,1,5-.21,6.92,6.92,0,0,1,2.55,1.17,5.51,5.51,0,0,1,1.79,2.39c.38,1,.59,2,.91,2.92a5.43,5.43,0,0,0,1.61,2.54,10.09,10.09,0,0,0,6.1,1.94c2.25.13,4.56.06,6.67.81a9.8,9.8,0,0,1,4.85,4,13.65,13.65,0,0,1,2,5.32,18.22,18.22,0,0,1,0,4.95,33.93,33.93,0,0,1-1.78,6.9c-.28.79-.51,1.4-.68,1.81A3,3,0,0,1,173.57,208.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.48,217.86a18,18,0,0,0,2.47-4A13.71,13.71,0,0,0,171,209a12.59,12.59,0,0,0-1.31-6c-.49-1-1.05-1.93-1.49-2.91a11.36,11.36,0,0,1-.87-3,16.66,16.66,0,0,0-1.1-4.94,4.79,4.79,0,0,0-2.31-2.34,5.72,5.72,0,0,0-1.21-.29s.11,0,.33-.05a2.75,2.75,0,0,1,1,.15,4.81,4.81,0,0,1,2.57,2.36,16.4,16.4,0,0,1,1.25,5,10.51,10.51,0,0,0,.86,2.84c.43.94,1,1.87,1.49,2.89a12.73,12.73,0,0,1,1.32,6.21,13.64,13.64,0,0,1-1.19,5.05A11.57,11.57,0,0,1,168.4,217a6,6,0,0,1-.66.67C167.58,217.8,167.49,217.87,167.48,217.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.77,242.72a13.23,13.23,0,0,1-2.53,1.11,28.74,28.74,0,0,1-6.46,1.73,14.38,14.38,0,0,1-6.67-.65,9.31,9.31,0,0,1-1.84-.89c-.4-.27-.6-.45-.58-.47s.93.52,2.53,1a15.75,15.75,0,0,0,6.49.47,35.68,35.68,0,0,0,6.41-1.55A15.41,15.41,0,0,1,159.77,242.72Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.65,249.74a11.14,11.14,0,0,0-8.47-8,27,27,0,0,0-8.67-.56,31.43,31.43,0,0,1-3.64.21,3.91,3.91,0,0,1,1-.21c.62-.11,1.53-.24,2.65-.36a24.28,24.28,0,0,1,8.84.42,12.29,12.29,0,0,1,7.17,5.06,7.85,7.85,0,0,1,1,2.49A2.8,2.8,0,0,1,181.65,249.74Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.44,272.66c-.1,0-.43-1.22-1.36-3.05a19.9,19.9,0,0,0-1.9-3.05,22.66,22.66,0,0,0-3-3.21,23.52,23.52,0,0,0-3.6-2.51,21.12,21.12,0,0,0-3.28-1.46c-1.95-.65-3.23-.81-3.21-.91a3.6,3.6,0,0,1,.9,0,9,9,0,0,1,1.05.17,11.84,11.84,0,0,1,1.37.34,18,18,0,0,1,3.4,1.39,19.68,19.68,0,0,1,6.75,5.86,18.47,18.47,0,0,1,1.85,3.17,12.2,12.2,0,0,1,.52,1.31,6.35,6.35,0,0,1,.32,1A3.18,3.18,0,0,1,170.44,272.66Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.55,294.73c-.09,0,.34-1.53.66-4a33,33,0,0,0,.27-4.39A36,36,0,0,0,155,281a35.15,35.15,0,0,0-1.34-5.2,34.73,34.73,0,0,0-1.72-4.05c-1.14-2.24-2.05-3.51-2-3.57a5.09,5.09,0,0,1,.7.86,21.1,21.1,0,0,1,1.59,2.54,28.43,28.43,0,0,1,1.85,4,33.75,33.75,0,0,1,1.41,5.28,33.27,33.27,0,0,1,.44,5.45,29.19,29.19,0,0,1-.38,4.44,21.87,21.87,0,0,1-.66,2.93A3.91,3.91,0,0,1,154.55,294.73Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,271.72c0-.09,1.07-.16,2.74-.58a19,19,0,0,0,10.86-7.46c1-1.41,1.44-2.39,1.52-2.35s-.05.27-.24.72a11.89,11.89,0,0,1-1,1.84,17.36,17.36,0,0,1-11.07,7.61,11.54,11.54,0,0,1-2.07.25A2.52,2.52,0,0,1,132,271.72Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.25,249.18s-.14.23-.48.57a10.73,10.73,0,0,1-1.62,1.23,15.2,15.2,0,0,1-6.34,2.06,30.17,30.17,0,0,1-6.67-.13,13,13,0,0,1-2.71-.47,16.79,16.79,0,0,1,2.75.1,37.83,37.83,0,0,0,6.57,0,16.79,16.79,0,0,0,6.22-1.86C142.44,249.86,143.19,249.11,143.25,249.18Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.56,229a4.07,4.07,0,0,1-1,.51c-.65.3-1.59.71-2.77,1.17a30.63,30.63,0,0,1-9.64,2.3,15.81,15.81,0,0,1-9.54-2.49,10.75,10.75,0,0,1-2.23-2,3.61,3.61,0,0,1-.62-.92,17.48,17.48,0,0,0,3.06,2.65,16.23,16.23,0,0,0,9.31,2.28,34.18,34.18,0,0,0,9.54-2.12l2.81-1A5.22,5.22,0,0,1,167.56,229Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.19,272.35c-.09,0-.37-1.21-1.06-3.11a32,32,0,0,0-3.58-7,31.62,31.62,0,0,0-5.22-5.87c-1.52-1.33-2.56-2-2.51-2.11a2.82,2.82,0,0,1,.78.42,18.42,18.42,0,0,1,2,1.41,27.42,27.42,0,0,1,8.91,13,20.84,20.84,0,0,1,.6,2.35A3.36,3.36,0,0,1,125.19,272.35Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.4,283.79a28.91,28.91,0,0,1,.13-3.48c.11-2.15.2-5.11.09-8.39s-.39-6.22-.64-8.36a34.26,34.26,0,0,1-.37-3.46,2.83,2.83,0,0,1,.26.9c.14.59.3,1.45.48,2.51a69.43,69.43,0,0,1,.79,8.4,66.45,66.45,0,0,1-.24,8.42c-.1,1.08-.21,1.95-.3,2.54A3.87,3.87,0,0,1,109.4,283.79Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.69,256.35a9.27,9.27,0,0,1-1.82,1.9,23.42,23.42,0,0,1-5.32,3.47,24,24,0,0,1-6,1.93,9.06,9.06,0,0,1-2.62.21,39.29,39.29,0,0,0,8.44-2.61A39.44,39.44,0,0,0,106.69,256.35Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.47,243.87a7,7,0,0,1-2,1.24,17.77,17.77,0,0,1-11,1.41,6.65,6.65,0,0,1-2.22-.71,27.38,27.38,0,0,0,7.78.38A27.5,27.5,0,0,0,104.47,243.87Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.11,227.55a6,6,0,0,1-1.81,1,17.53,17.53,0,0,1-4.82,1.19,17.86,17.86,0,0,1-5-.2,6.58,6.58,0,0,1-2-.59,34.93,34.93,0,0,0,6.88.27A34,34,0,0,0,101.11,227.55Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.05,289.52s-.67,0-1.86.08a21.11,21.11,0,0,0-4.92,1,47.2,47.2,0,0,0-6.87,3,64.63,64.63,0,0,1-8.44,3.78,24.47,24.47,0,0,1-9.18,1.14,25.18,25.18,0,0,1-7.38-1.62,21.58,21.58,0,0,1-4.52-2.34c-.51-.32-.87-.63-1.12-.81a1.9,1.9,0,0,1-.36-.32,33.21,33.21,0,0,0,6.13,3.13,25.92,25.92,0,0,0,7.28,1.48,24.09,24.09,0,0,0,9-1.16,66.7,66.7,0,0,0,8.38-3.71,44,44,0,0,1,7-2.88,19,19,0,0,1,5-.84,9.08,9.08,0,0,1,1.38,0A1.42,1.42,0,0,1,178.05,289.52Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.77,275.38a17.66,17.66,0,0,1-5.16,1.62,17.35,17.35,0,0,1-5.38.46c0-.15,2.38-.4,5.28-1S178.72,275.23,178.77,275.38Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.49,301.21a2.17,2.17,0,0,1-.49.21l-1.42.5c-1.24.43-3.06,1-5.32,1.6A120.57,120.57,0,0,1,137,307.68c-2.34-.09-4.23-.22-5.54-.36l-1.5-.16a1.88,1.88,0,0,1-.52-.09,2,2,0,0,1,.53,0l1.51.06c1.3.08,3.19.15,5.53.19a138.15,138.15,0,0,0,18.23-.85,140.06,140.06,0,0,0,17.94-3.29c2.26-.58,4.09-1.08,5.35-1.44l1.45-.41A3.38,3.38,0,0,1,180.49,301.21Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152.29,295.69a23.55,23.55,0,0,0,8.55,1.77,12.5,12.5,0,0,0,8.11-2.84c2.68-2.37,3.88-6,4.84-9.4a101.36,101.36,0,0,0,2.89-23.32s-5.81,12-7.89,15.69c-1.85,3.25-3.75,6.57-6,11.3-1.8,3.83-6.11,6.45-10.51,6.8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.35,245.26a34.79,34.79,0,0,0,.25,28.5L130,268Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M426.57,443.31c.68-2.69-1.1-5.37-3.08-7.31s-4.35-3.66-5.4-6.23c-1.68-4.16.52-9.58-2.33-13-1.69-2-4.68-2.71-6.18-4.88a11.29,11.29,0,0,1-1.35-3.91,39.64,39.64,0,0,0-10-18.41,34.47,34.47,0,0,0,4,17.78c1.16,2.18,2.58,4.31,3,6.75.64,4-1.55,8.05-.56,11.94,1.14,4.45,6.16,7.4,6.42,12,.23,3.87-3.13,7.29-2.86,11.17a10.51,10.51,0,0,0,1.75,4.58c3,5,7.45,8.37,14.12,8.22l8.17.24Z",
    style: {
      fill: "#474af0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M426.57,443.31c.68-2.69-1.1-5.37-3.08-7.31s-4.35-3.66-5.4-6.23c-1.68-4.16.52-9.58-2.33-13-1.69-2-4.68-2.71-6.18-4.88a11.29,11.29,0,0,1-1.35-3.91,39.64,39.64,0,0,0-10-18.41,34.47,34.47,0,0,0,4,17.78c1.16,2.18,2.58,4.31,3,6.75.64,4-1.55,8.05-.56,11.94,1.14,4.45,6.16,7.4,6.42,12,.23,3.87-3.13,7.29-2.86,11.17a10.51,10.51,0,0,0,1.75,4.58c3,5,7.45,8.37,14.12,8.22l8.17.24Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M433.9,462.39h.58a10.93,10.93,0,0,0,1.66-.17,13.9,13.9,0,0,0,2.61-.73,10.92,10.92,0,0,0,3.19-1.82A4.34,4.34,0,0,0,443.2,458a8.48,8.48,0,0,0,.34-2.37,22.8,22.8,0,0,1,.15-2.68,7.58,7.58,0,0,1,1-2.74c1-1.74,2.52-3.34,3-5.54s.1-4.56-.31-7-.81-5.2.13-7.87,2.66-5,3.49-7.75.41-5.88.57-9a12.46,12.46,0,0,1,1.07-4.71c.67-1.49,1.58-2.87,2.26-4.35,1.38-3,1.62-6.42,2-9.85.18-1.73.36-3.47.55-5.23a25.94,25.94,0,0,1,.89-5.32,45.22,45.22,0,0,1,1.94-5.12,17.6,17.6,0,0,0,.9-2.55,26.64,26.64,0,0,0,.24-2.73,33.57,33.57,0,0,0-.25-5.57c-.23-1.86-.58-3.73-.8-5.64l0-.33.38.2a12.13,12.13,0,0,0-4.2,3.59,19.29,19.29,0,0,0-2.6,4.86c-1.32,3.45-1.8,7.09-2.47,10.63A29.55,29.55,0,0,1,448,390.88c-.91,1.5-2,2.83-2.92,4.23a11.08,11.08,0,0,0-1.93,4.47c-.47,3.22,1.43,6.26,1.06,9.52a11,11,0,0,1-1.54,4.42c-.75,1.34-1.63,2.56-2.45,3.78a22.7,22.7,0,0,0-2.14,3.7,11.62,11.62,0,0,0-1,4c-.19,2.69.2,5.31,0,7.83a18.2,18.2,0,0,1-2,6.85c-1,2-2.1,3.84-3,5.59-.46.88-.89,1.74-1.23,2.58a12.8,12.8,0,0,0-.71,2.53,16.2,16.2,0,0,0-.08,4.59,11.92,11.92,0,0,0,2.25,5.9,10.64,10.64,0,0,0,1.59,1.55s-.16-.1-.46-.32a3.28,3.28,0,0,1-.54-.45,5.86,5.86,0,0,1-.67-.71,11.81,11.81,0,0,1-2.37-5.94,16.57,16.57,0,0,1,0-4.66,12.85,12.85,0,0,1,.71-2.59,26.5,26.5,0,0,1,1.22-2.61c.91-1.77,2-3.59,3-5.61a18,18,0,0,0,2-6.73c.18-2.46-.22-5.08,0-7.83a11.88,11.88,0,0,1,1-4.1,24.76,24.76,0,0,1,2.18-3.79c.82-1.22,1.68-2.43,2.42-3.74a10.71,10.71,0,0,0,1.46-4.25c.38-3.07-1.54-6.09-1.08-9.55a11.69,11.69,0,0,1,2-4.67c.94-1.42,2-2.76,2.91-4.22a29.07,29.07,0,0,0,3.3-9.9c.67-3.51,1.14-7.2,2.48-10.71a19.8,19.8,0,0,1,2.68-5,12.51,12.51,0,0,1,4.37-3.73l.33-.17.05.37,0,.33c.21,1.88.56,3.75.79,5.64a32.44,32.44,0,0,1,.25,5.65,26.86,26.86,0,0,1-.24,2.81,16.92,16.92,0,0,1-.94,2.65,45.32,45.32,0,0,0-1.92,5.07,25,25,0,0,0-.88,5.23c-.19,1.76-.37,3.5-.56,5.22-.38,3.42-.61,6.91-2,10-.71,1.53-1.62,2.89-2.27,4.34a12,12,0,0,0-1,4.55c-.17,3.09.26,6.21-.62,9.13s-2.65,5.2-3.52,7.76-.54,5.23-.14,7.68.81,4.9.26,7.16-2.09,3.91-3.05,5.61a7.28,7.28,0,0,0-1,2.63,24.24,24.24,0,0,0-.18,2.65,8.14,8.14,0,0,1-.37,2.44,4.49,4.49,0,0,1-1.34,1.8,11.12,11.12,0,0,1-3.26,1.82,13.68,13.68,0,0,1-2.66.68A6.44,6.44,0,0,1,433.9,462.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.18,366a1.68,1.68,0,0,1,0,.26c0,.2-.07.44-.12.74-.13.66-.28,1.62-.56,2.87s-1,2.64-1.59,4.33-1.25,3.62-1.83,5.8-1.1,4.59-1.64,7.19a30.7,30.7,0,0,1-2.56,8.12c-.67,1.34-1.4,2.69-2,4.12a19.06,19.06,0,0,0-1.11,4.58,91.09,91.09,0,0,1-1.7,9.94c-1.62,6.71-3.15,13.09-4.56,18.91s-2.78,11-3.89,15.39L435,458.61l-.75,2.81c-.08.3-.15.54-.21.73s-.08.25-.09.24,0-.08,0-.25.1-.44.16-.74l.66-2.84,2.5-10.4c1.08-4.41,2.37-9.63,3.79-15.43s2.91-12.2,4.51-18.9a95.54,95.54,0,0,0,1.71-9.9,18.94,18.94,0,0,1,1.15-4.69c.59-1.48,1.33-2.82,2-4.15a30.75,30.75,0,0,0,2.57-8c.56-2.59,1.1-5,1.71-7.2a61.07,61.07,0,0,1,1.91-5.81c.62-1.69,1.35-3.06,1.67-4.27s.49-2.19.64-2.84l.18-.73A.76.76,0,0,1,459.18,366Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.35,462.41c5.32-3.2,6.79-12.84,4.53-18.62s-6.18-11.06-6.82-17.23c-.49-4.75,1-9.64-.09-14.27-1.53-6.26-7.68-11.08-7.64-17.52,0-3.61,2.05-7,1.87-10.64-.23-4.42-3.64-7.92-5.77-11.81-3.26-5.95-3.51-13-4.65-19.7s-3.73-13.84-9.68-17.1c-.85,5.69-2.32,9.59-1.81,17.29.19,2.77,3.43,8,3.9,14.1.28,3.62.48,7.25.73,10.87s.48,7.12,1.76,10.41c1,2.53,2.56,4.81,3.29,7.42,1.38,4.91-.37,10.24.75,15.21.95,4.21,3.89,7.82,4.51,12.09.88,6-3,12.27-1,18,1,2.84,3.35,5.11,4,8,.53,2.27,0,4.69.46,7,.77,3.68,7.82,6.5,11.58,6.25",
    style: {
      fill: "#474af0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.6,341.16a1.87,1.87,0,0,1,.08.31c0,.24.1.54.17.92.16.81.34,2,.66,3.56s1.17,3.27,1.86,5.4,1.44,4.56,2.08,7.31,1.2,5.77,1.77,9A37.53,37.53,0,0,0,418,377.76c.75,1.69,1.62,3.4,2.28,5.25a24,24,0,0,1,1.19,5.88,120.29,120.29,0,0,0,1.64,12.38c1.67,8.41,3.26,16.42,4.7,23.71s2.84,13.83,4,19.34,2,9.94,2.63,13.05c.3,1.52.53,2.71.69,3.56.07.38.13.69.17.92a1.92,1.92,0,0,1,0,.32,1.31,1.31,0,0,1-.09-.31c-.06-.23-.13-.53-.22-.91-.19-.84-.45-2-.79-3.54-.66-3.1-1.62-7.54-2.79-13s-2.55-12-4.09-19.32-3.06-15.31-4.74-23.72A113.49,113.49,0,0,1,421,388.94a24,24,0,0,0-1.16-5.76c-.64-1.82-1.49-3.52-2.25-5.22a38.11,38.11,0,0,1-2.8-10.2c-.55-3.26-1.08-6.29-1.7-9s-1.31-5.18-2-7.3-1.47-3.88-1.78-5.45-.43-2.76-.56-3.58c-.05-.39-.09-.69-.13-.93A1.54,1.54,0,0,1,408.6,341.16Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.64,462.83l-131.53-.08a28.66,28.66,0,0,1-28.64-28.66l.07-329.75A28.65,28.65,0,0,1,215.2,75.69l131.54.08a28.65,28.65,0,0,1,28.63,28.66l-.06,329.75A28.66,28.66,0,0,1,346.64,462.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.6,87.43H321.1a6.34,6.34,0,0,0-6.2,6.47v4.62a6.33,6.33,0,0,1-6.19,6.47L259,105a6.34,6.34,0,0,1-6.19-6.47V93.85a6.34,6.34,0,0,0-6.19-6.48h-9l-22.32,0a20.07,20.07,0,0,0-20.08,20.07l-.06,321.86a20.06,20.06,0,0,0,20.05,20.07l131.27.08a20.08,20.08,0,0,0,20.08-20.06l.06-321.87A20.06,20.06,0,0,0,346.6,87.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.48,119.93c0,.09-3.32.19-7.41.22s-7.41,0-7.41-.1,3.32-.18,7.41-.21S350.48,119.85,350.48,119.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.51,123.72c0,.09-3.32.19-7.41.22s-7.41,0-7.41-.09,3.32-.19,7.41-.22S350.51,123.64,350.51,123.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.54,127.51c0,.09-3.32.19-7.41.22s-7.41,0-7.41-.09,3.32-.19,7.41-.22S350.54,127.43,350.54,127.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.73,131.84l.3,0,.86,0,3.16-.07-.08.08c0-.7,0-1.46,0-2.29,0-.43,0-.83,0-1.32a1.22,1.22,0,0,1,1.07-1c.51,0,.95,0,1.51,0a1.22,1.22,0,0,1,1,1.22c0,1.07,0,2.19,0,3.34l-.14-.14,4,0-.16.15c0-1.6,0-3.27,0-5,0-.42,0-.84,0-1.26a1.3,1.3,0,0,0-.56-1l-1.75-1.72-1.68-1.66-.81-.8c-.29-.27-.51-.55-.83-.62a1.08,1.08,0,0,0-.92.18c-.24.2-.5.49-.74.73l-1.43,1.44c-.9.94-1.84,1.79-2.52,2.6a2.79,2.79,0,0,0-.2,1.49c0,.49,0,1,0,1.4,0,.87,0,1.62,0,2.27s0,1.06,0,1.45,0,.51,0,.52a2.76,2.76,0,0,1,0-.48c0-.39,0-.86,0-1.43s0-1.41,0-2.28c0-.45,0-.93,0-1.43,0-.26,0-.52,0-.79a1.66,1.66,0,0,1,.22-.83c.74-.91,1.62-1.71,2.52-2.67l1.43-1.46c.25-.25.46-.5.77-.76a1.37,1.37,0,0,1,1.15-.23,2.15,2.15,0,0,1,1,.69l.82.8,1.69,1.65,1.75,1.72a3.44,3.44,0,0,1,.44.48,1.36,1.36,0,0,1,.21.68c0,.42,0,.84,0,1.27,0,1.7,0,3.36,0,5v.16h-.15l-4,0h-.15v-.14c0-1.16,0-2.28,0-3.35a1,1,0,0,0-.8-1c-.46,0-1,0-1.45,0a1,1,0,0,0-.86.77c0,.41,0,.87,0,1.28v2.38h-.08l-3.22,0H216A1.15,1.15,0,0,1,215.73,131.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.77,
    y: 151.87,
    width: 139.93,
    height: 25.45,
    rx: 10.73,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339,177.33l.8-.07a11.46,11.46,0,0,0,2.31-.45,10.87,10.87,0,0,0,3.36-1.77,10.55,10.55,0,0,0,3.2-4,10.18,10.18,0,0,0,.84-3,29.35,29.35,0,0,0,.1-3.43,23.67,23.67,0,0,0-.17-3.73,10.46,10.46,0,0,0-1.39-3.73,10.6,10.6,0,0,0-7.06-4.91,29.91,29.91,0,0,0-4.87-.18h-5.17l-110.41.07a10.51,10.51,0,0,0-10.44,9.61c-.08,1.26,0,2.6,0,3.9a12.2,12.2,0,0,0,.4,3.78,10.5,10.5,0,0,0,4.33,5.93,10.09,10.09,0,0,0,3.39,1.45,15.51,15.51,0,0,0,3.68.27h21.76l49.64,0,33.47.09,9.09,0,2.37,0,.81,0-.81,0-2.37,0-9.09.05-33.47.08-49.64.06H221.83a15.71,15.71,0,0,1-3.79-.29,10.58,10.58,0,0,1-3.56-1.51,11.07,11.07,0,0,1-4.55-6.22,12.72,12.72,0,0,1-.42-3.92c0-1.31,0-2.59.05-3.95a11,11,0,0,1,10.95-10.08l110.41.08h5.17a28.71,28.71,0,0,1,4.93.21,10.89,10.89,0,0,1,8.66,8.92,23.08,23.08,0,0,1,.14,3.77,26.07,26.07,0,0,1-.12,3.46,10.3,10.3,0,0,1-.88,3,10.57,10.57,0,0,1-3.28,4.08,11,11,0,0,1-3.43,1.75,10.37,10.37,0,0,1-2.34.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.13,164c-.05,0-.05-.41-.25-1.1a4.5,4.5,0,0,0-1.69-2.41,4.38,4.38,0,1,0,0,7,4.52,4.52,0,0,0,1.69-2.42c.2-.69.2-1.1.25-1.1a.78.78,0,0,1,0,.3,3.2,3.2,0,0,1-.08.85,4.52,4.52,0,0,1-1.66,2.66,4.79,4.79,0,0,1-4.56.75,4.84,4.84,0,0,1,0-9.11,4.79,4.79,0,0,1,4.56.74,4.63,4.63,0,0,1,1.66,2.66,3.3,3.3,0,0,1,.08.86A.74.74,0,0,1,341.13,164Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.66,171.94a9.16,9.16,0,0,1-2.25-2.05,9.41,9.41,0,0,1-1.88-2.42,9.33,9.33,0,0,1,2.26,2.06A9.19,9.19,0,0,1,343.66,171.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.66,162.05h-2.49v-.64h5.74v.64h-2.5v6.46h-.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,166.06h-4.46a2,2,0,0,0,2.1,1.86,2.08,2.08,0,0,0,1.63-.7l.41.47a2.82,2.82,0,0,1-4.86-1.85,2.57,2.57,0,0,1,2.61-2.71,2.54,2.54,0,0,1,2.58,2.71C237.05,165.9,237,166,237,166.06Zm-4.46-.54h3.78a1.89,1.89,0,0,0-3.78,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.77,168.51l-1.69-2.23-1.71,2.23h-.81l2.11-2.74-2-2.6h.81l1.61,2.09,1.6-2.09h.79l-2,2.6,2.13,2.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.6,168.18a1.68,1.68,0,0,1-1.13.38,1.41,1.41,0,0,1-1.56-1.55v-3.23H243v-.61h.95V162h.72v1.17h1.63v.61h-1.63V167a.86.86,0,0,0,.93,1,1.22,1.22,0,0,0,.79-.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.67,
    y: 198.27,
    width: 30.63,
    height: 30.63,
    style: {
      fill: "#474af0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.22,201.57c0,.14-10.24.26-22.87.26s-22.88-.12-22.88-.26,10.24-.26,22.88-.26S305.22,201.42,305.22,201.57Z",
    style: {
      fill: "#474af0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.7,211c0,.15-18.41.26-41.11.26s-41.12-.11-41.12-.26,18.41-.26,41.12-.26S341.7,210.81,341.7,211Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.73,217.66c0,.14-18.19.26-40.63.26s-40.63-.12-40.63-.26,18.19-.26,40.63-.26S340.73,217.52,340.73,217.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.45,224.06c0,.14-10.74.26-24,.26s-24-.12-24-.26,10.74-.26,24-.26S307.45,223.91,307.45,224.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.67,
    y: 249.3,
    width: 30.63,
    height: 30.63,
    style: {
      fill: "#474af0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.22,252.59c0,.15-10.24.26-22.87.26s-22.88-.11-22.88-.26,10.24-.26,22.88-.26S305.22,252.45,305.22,252.59Z",
    style: {
      fill: "#474af0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.7,262c0,.15-18.41.26-41.11.26s-41.12-.11-41.12-.26,18.41-.26,41.12-.26S341.7,261.84,341.7,262Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.73,268.69c0,.14-18.19.26-40.63.26s-40.63-.12-40.63-.26,18.19-.26,40.63-.26S340.73,268.54,340.73,268.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.45,275.08c0,.15-10.74.26-24,.26s-24-.11-24-.26,10.74-.26,24-.26S307.45,274.94,307.45,275.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.67,
    y: 300.33,
    width: 30.63,
    height: 30.63,
    style: {
      fill: "#474af0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.22,303.62c0,.15-10.24.26-22.87.26s-22.88-.11-22.88-.26,10.24-.26,22.88-.26S305.22,303.48,305.22,303.62Z",
    style: {
      fill: "#474af0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.7,313c0,.14-18.41.26-41.11.26s-41.12-.12-41.12-.26,18.41-.26,41.12-.26S341.7,312.87,341.7,313Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.73,319.72c0,.14-18.19.26-40.63.26s-40.63-.12-40.63-.26,18.19-.27,40.63-.27S340.73,319.57,340.73,319.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.45,326.11c0,.15-10.74.26-24,.26s-24-.11-24-.26,10.74-.26,24-.26S307.45,326,307.45,326.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.67,
    y: 351.35,
    width: 30.63,
    height: 30.63,
    style: {
      fill: "#474af0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.22,354.65c0,.14-10.24.26-22.87.26s-22.88-.12-22.88-.26,10.24-.26,22.88-.26S305.22,354.51,305.22,354.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.7,364c0,.14-18.41.26-41.11.26s-41.12-.12-41.12-.26,18.41-.26,41.12-.26S341.7,363.89,341.7,364Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.73,370.74c0,.15-18.19.26-40.63.26s-40.63-.11-40.63-.26,18.19-.26,40.63-.26S340.73,370.6,340.73,370.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.45,377.14c0,.14-10.74.26-24,.26s-24-.12-24-.26,10.74-.26,24-.26S307.45,377,307.45,377.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.67,
    y: 402.38,
    width: 30.63,
    height: 30.63,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.22,405.68c0,.14-10.24.26-22.87.26s-22.88-.12-22.88-.26,10.24-.26,22.88-.26S305.22,405.53,305.22,405.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.7,415.07c0,.14-18.41.26-41.11.26s-41.12-.12-41.12-.26,18.41-.26,41.12-.26S341.7,414.92,341.7,415.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.73,421.77c0,.14-18.19.26-40.63.26s-40.63-.12-40.63-.26,18.19-.26,40.63-.26S340.73,421.63,340.73,421.77Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.45,428.17c0,.14-10.74.26-24,.26s-24-.12-24-.26,10.74-.26,24-.26S307.45,428,307.45,428.17Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 215.67,
    y: 351.35,
    width: 30.63,
    height: 30.63
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 215.67,
    y: 249.3,
    width: 30.63,
    height: 30.63
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeo);
export default __webpack_public_path__ + "static/media/seo.870569efd51654f51aa0c02404d67a4e.svg";
export { ForwardRef as ReactComponent };